<template>
  <div class="sj-table-filter">
    <SjSelect
      :border="false"
      :multiple="multiple"
      class="sj-table-filter-input"
      size="small"
      :placeholder="placeholder"
      :options="options"
      v-model="filter"
      :max-height="200"
    >
    </SjSelect>
    <!-- <div class="sj-table-filter-suffix">
    <i class="iconfont icon-icon_select" @click="check" />
    <i class="iconfont icon-icon_close" @click="clear" />
  </div> -->
  </div>
</template>

<script>
export default {
  name: "table-filter-category",
  props: {
    type: {
      type: String,
      validator(v){
        return ['single', 'multiple'].indexOf(v) !== -1
      }
    },  
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: "过滤"
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filter: this.type === 'single' ? null : []
    };
  },
  methods: {
    clearFilter() {
      this.filter = this.type === 'single' ? null : [];
    },
    clear() {
      this.clearFilter();
      this.check();
      this.focus();
    },
    check() {
      this.$emit("filter", this.filter);
    },
    focus() {
      this.$nextTick(() => {
        this.$refs.filter.focus();
      });
    }
  },
  watch: {
    filter() {
      this.$emit("filter", this.filter);
    }
  }
};
</script>

<style lang="less" scoped>
.sj-table-filter {
  position: relative;

  .sj-table-filter-input {
    width: 100%;
  }
  .sj-table-filter-suffix {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
  }
}
</style>
